import { render, staticRenderFns } from "./AmbulatoryCharts.vue?vue&type=template&id=012da4cd&"
import script from "./AmbulatoryCharts.vue?vue&type=script&lang=js&"
export * from "./AmbulatoryCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports